import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { isSafeRedirect } from '../lib/redirectGuard';

/**
 * Magic-link landing page.  The API sets an HttpOnly cookie before redirecting
 * here.  We simply read the navigation params and redirect to the target view;
 * the cookie is sent automatically on subsequent API requests.
 */
export default function ActionLandingPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const tabs     = params.get('tabs');
    const active   = params.get('active');
    const action   = params.get('action');
    const redirect = params.get('redirect');

    if (tabs && active) {
      navigate(`/artefacts?tabs=${tabs}&active=${active}${action ? `&action=${action}` : ''}`, { replace: true });
    } else if (isSafeRedirect(redirect)) {
      // #3248 — an unsafe `redirect` is dropped (falls through to /projects).
      navigate(redirect, { replace: true });
    } else {
      navigate('/projects', { replace: true });
    }
  }, [params, navigate]);

  return null;
}
